import { AxiosInstance } from 'axios';

import { IdleResourcesAPIApiFactory } from '@cast/openapi';

import { AXIOS_CONFIGURATION } from '../constants';

export const IdleResourcesApiAdapter = (client: AxiosInstance) => {
  const generatedIdleResourcesApi = IdleResourcesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    listIdleDisks: generatedIdleResourcesApi.idleResourcesAPIListIdleDisks,
  };
};
